export const KIND = {
    primary: 'primary',
    secondary: 'secondary',
    tertiary: 'tertiary',
};
export const SHAPE = {
    default: 'default',
    pill: 'pill',
    round: 'round',
};
export const SIZE = {
    compact: 'compact',
    large: 'large',
    medium: 'medium',
    small: 'small',
};
export const COLOR = {
    primary: 'primary',
    secondary: 'secondary',
};
export const ICON_SIZE = {
    compact: '16px',
    small: '16px',
    medium: '20px',
    large: '24px',
};
